import { render } from "./HomeGlobal.vue?vue&type=template&id=428138a6&scoped=true"
import script from "./HomeGlobal.vue?vue&type=script&lang=js"
export * from "./HomeGlobal.vue?vue&type=script&lang=js"

import "./HomeGlobal.vue?vue&type=style&index=0&id=428138a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428138a6"]])

export default __exports__